/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useToken } from '../../../../providers/Token.provider';
import { useBank } from '../../../../providers/Bank.provider';
import usePostLinkBankAccountManually from '../../../../hooks/useApi/usePostLinkBankAccountManually';
import useFetchFinancialInstitutionBranches from '../../../../hooks/useApi/useFetchFinancialInstitutionBranches';
import ManualBankAccountForm from './ManualBankAccountForm';
import { usePaylink } from '../../../../providers/Paylink.provider';
import usePostPaylinkSetAccount from '../../../../hooks/useApi/usePostPaylinkSetAccount';
import { useFlexiblePayment } from '../../../../providers/FlexiblePayment.provider';
import { BankSuccessDialogueHandler, DialogueHandlerProps } from '../SuccessDialouge/types';
import { useTranslation } from 'react-i18next';
import { useLayout } from '@/providers/Layout.provider';
import { ConfirmationDialogue } from 'vopay';

type ManualBankAccountContainerProps = {
  shouldConnectBank: boolean;
  isFormCompleted: boolean;
  setIsFormCompleted: (val: boolean) => void;
};

type FC = FunctionComponent<ManualBankAccountContainerProps>;

const ManualBankAccountContainer: FC = (props: ManualBankAccountContainerProps) => {
  const { shouldConnectBank, isFormCompleted, setIsFormCompleted } = props;
  const { token, isSetByBrowser } = useToken();
  const { FinancialInstitution, BankAccountRail } = useBank();
  const [BankId, setBankId] = useState('0');
  const parsedBankID = parseFloat(BankId || '0');

  const [errorMessage, setErrorMessage] = useState('');
  const { t } = useTranslation('translations', { keyPrefix: 'ManualBank' });
  const { color } = useLayout();
  const history = useHistory();
  const [financialInstitutionBranchesResponse, fetchFinancialInstitutionBranches] =
    useFetchFinancialInstitutionBranches({});
  const { paylink, Token } = usePaylink();
  const { paymentMethods, paymentType, partialPaymentValues, addPaymentMethod, isFlexiblePayment, installmentDetails } =
    useFlexiblePayment();
  const [paylinkAccountResponse, setPaylinkAccount] = usePostPaylinkSetAccount({});
  const [linkBankAccountResponse, linkBankAccount] = usePostLinkBankAccountManually({});

  useEffect(() => {
    setBankId(String(FinancialInstitution?.FinancialInstitutionID));
  }, [FinancialInstitution]);

  const initialFormValue = {
    FinancialInstitutionNumber:
      parsedBankID !== 0 ? FinancialInstitution?.FinancialInstitutionNumber || undefined : undefined,
    Country: token?.Country || 'CA',
    FirstName: paylink.ReceiverName?.split(' ')[0] || '',
    LastName: paylink.ReceiverName?.split(' ')[1] || '',
    EmailAddress: paylink.ReceiverEmailAddress,
    PhoneNumber: paylink.ReceiverPhoneNumber,
    AccountNumber: undefined,
    Currency: paylink.Currency && paylink.Currency !== '' ? paylink.Currency : token?.Country === 'US' ? 'USD' : 'CAD',
    BranchTransitNumber: undefined,
    RoutingNumber: undefined,
    CompanyName: paylink.ReceiverName,
    Address: '',
    City: '',
    Province: '',
    PostalCode: '',
  };
  const [linkBankAccountManuallyRequest, setLinkBankAccountManuallyRequest] =
    useState<vp.LinkBankAccountManuallyRequest>(initialFormValue);
  const [isLinkBankAccount, setIsLinkBankAccount] = useState(false);
  const [isLinkAccount, setIsLinkAccount] = useState(false);
  useEffect(() => {
    if (FinancialInstitution?.FinancialInstitutionID) {
      fetchFinancialInstitutionBranches({
        FinancialInstitutionID: Number(FinancialInstitution?.FinancialInstitutionID),
      });
    }
  }, [FinancialInstitution]);

  const handlers = {
    linkBankAccount: (_values: vp.LinkBankAccountManuallyRequest) => {
      setIsLinkBankAccount(true);
      setLinkBankAccountManuallyRequest(_values);
      linkBankAccount(_values);
    },
    handleSuccessDialogue: (handlerProps: DialogueHandlerProps<BankSuccessDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;

      const dialogueHandlers: BankSuccessDialogueHandler = {
        create: {
          success: {
            default: () => {
              const redirectMethod = token?.RedirectMethod;
              const url = `${token?.RedirectURL || ''}?Token=${linkBankAccountResponse.Token}&PaymentMethod=bank`;
              if (redirectMethod === 'InnerRedirect') {
                window.location.href = url;
              } else if (redirectMethod === 'OuterRedirect') {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                window.top!.location.href = url;
              }
              // setShowConnectBankSuccessAlert(false);
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;
      handler();
    },
  };
  const completePaylink = () => {
    if (isFlexiblePayment) {
      if (paymentType === vp.FlexiblePaymentMethods.MultiplePaymentMethods) {
        const paymentMethod = paymentMethods.find((method) => method.method === vp.ConnectionTypes.Bank);
        addPaymentMethod({
          ...paymentMethod,
          amount: paymentMethod?.amount || 0,
          FinancialInstitution,
          token: linkBankAccountResponse.Token,
          account: linkBankAccountManuallyRequest?.AccountNumber?.toString() || '',
          method: vp.ConnectionTypes.Bank,
        });
        history.push('/connect/flexible-payment/multiple-payment-methods');
      }
      if (paymentType === vp.FlexiblePaymentMethods.PartialPayment) {
        setIsLinkAccount(true);
        setPaylinkAccount({
          SingleUseToken: Token,
          Iq11Token: linkBankAccountResponse.Token,
          PaymentMethod: 'bank',
          FlexiblePaymentOptions: {
            PaymentOption: 'partial',
            PartialPaymentDetails: partialPaymentValues,
          },
        });
      }
      if (paymentType === vp.FlexiblePaymentMethods.InstallmentPlan) {
        setIsLinkAccount(true);
        setPaylinkAccount({
          SingleUseToken: Token,
          Iq11Token: linkBankAccountResponse.Token,
          PaymentMethod: 'bank',
          FlexiblePaymentOptions: {
            PaymentOption: 'installments',
            InstallmentDetails: installmentDetails,
          },
        });
      }
    } else {
      setIsLinkAccount(true);
      setPaylinkAccount({
        SingleUseToken: Token,
        Iq11Token: linkBankAccountResponse.Token,
        PaymentMethod: 'bank',
        BankAccountRail: BankAccountRail,
      });
    }
  };

  useEffect(() => {
    if (isLinkBankAccount) {
      if (linkBankAccountResponse.Success) {
        const redirectMethod = token?.RedirectMethod;
        const url = `${token?.RedirectURL || ''}?Token=${linkBankAccountResponse.Token}&PaymentMethod=bank`;

        const Response = {
          Step: 'LINK',
          Institution: FinancialInstitution?.FIName || '',
          Url: url,
          Token: linkBankAccountResponse.Token,
          BankId: FinancialInstitution?.FinancialInstitutionID || '',
          AccountNumber: linkBankAccountManuallyRequest?.AccountNumber || '',
          InstitutionNumber: linkBankAccountManuallyRequest?.FinancialInstitutionNumber || '',
          BranchTransitNumber: linkBankAccountManuallyRequest?.BranchTransitNumber || '',
          RoutingNumber: linkBankAccountManuallyRequest?.RoutingNumber || '',
          PaymentMethod: 'bank',
          ConnectionType: 'manual',
        };
        window.top?.postMessage(Response, '*');
        if (window.parent && window.parent !== window.top) {
          window.parent.postMessage(Response, '*');
        }
        if (Token) {
          completePaylink();
        } else if (!isSetByBrowser) {
          history.push('/dashboard');
        }
        setTimeout(() => {
          if (isSetByBrowser) {
            if (redirectMethod === 'InnerRedirect') {
              window.location.href = url;
            } else if (redirectMethod === 'OuterRedirect') {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              window.top!.location.href = url;
            } else {
              history.push('/success');
            }
          }
          setIsLinkBankAccount(false);
        }, 300);
      } else {
        setErrorMessage(linkBankAccountResponse.ErrorMessage || '');
      }
    }
  }, [linkBankAccountResponse]);
  useEffect(() => {
    if (isLinkAccount && paylinkAccountResponse) {
      setIsLinkAccount(false);
      if (paylinkAccountResponse.Success) {
        history.push('/thank-you', {
          paymentMethodType: 'bank',
          paymentMethod: linkBankAccountManuallyRequest?.AccountNumber,
          connectionType: 'manual',
          bankId: FinancialInstitution?.FinancialInstitutionID || '',
          accountNumber: linkBankAccountManuallyRequest?.AccountNumber || '',
          institutionNumber: linkBankAccountManuallyRequest?.FinancialInstitutionNumber || '',
          branchTransitNumber: linkBankAccountManuallyRequest?.BranchTransitNumber || '',
          routingNumber: linkBankAccountManuallyRequest?.RoutingNumber || '',
          currency: linkBankAccountManuallyRequest?.Currency || (token?.Country === 'US' ? 'USD' : 'CAD'),
        });
      } else {
        history.push('/connect/transaction-error');
      }
    }
  }, [paylinkAccountResponse]);

  return (
    <>
      <ManualBankAccountForm
        financialInstitutionBranches={financialInstitutionBranchesResponse}
        handlers={handlers}
        BankId={parsedBankID}
        defaultValues={initialFormValue}
        shouldConnectBank={shouldConnectBank}
        isFormCompleted={isFormCompleted}
        setIsFormCompleted={setIsFormCompleted}
      />
      <ConfirmationDialogue
        isVisible={!!errorMessage}
        title={t('error', {
          defaultValue: 'Error',
        })}
        variant="creditCard"
        buttonTextColor={vp.getContrastColor(color)}
        status="fail"
        buttonColor="primary"
        subTitle={errorMessage}
        confirm={{
          label: t('backButton', {
            defaultValue: 'Back',
          }),
          action: () => setErrorMessage(''),
        }}
      />
    </>
  );
};

export default ManualBankAccountContainer;
